import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.slot_inspector.json";

export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "slot_inspector", fallbackMessages });

/**
 * Translates a Slot Inspector string. Keys are relative to `frontend.slot_inspector`.
 *
 * @param {String} key
 * @param {Object} [values] - Interpolation values.
 * @returns {String}
 */
export function t(key, values) {
  return i18n.global.t(key, values);
}
